import { ReportGroupBy } from '../filter/filter.const';

export const Filter = [
  { id: ReportGroupBy.Day, text: 'ngày' },
  { id: ReportGroupBy.Hour, text: 'giờ' },
  { id: ReportGroupBy.Source, text: 'nguồn' },
  { id: ReportGroupBy.Group, text: 'bộ phận' },
];
export class AgentConst {
  static displayColumns = groupBy => {
    const groups = groupBy.split(',');
    let data = [
      {
        title: 'Tổng số cuộc',
        key: 'totalCalls',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Tổng số cuộc trả lời',
        key: 'totalAnswerCalls',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Tổng số cuộc nhỡ',
        key: 'totalMissCalls',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Tổng số cuộc từ chối',
        key: 'totalRejectCalls',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Tổng số cuộc kết thúc trước',
        key: 'totalByeCalls',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Tổng thời gian trả lời',
        key: 'totalAcdTimeFmt',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Tổng thời gian cuộc gọi',
        key: 'totalDurationFmt',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Tốc độ trả lời TB',
        key: 'avgSpeedAnswer',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Tỉ lệ cuộc nhỡ',
        key: 'missRatio',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Thời gian hold TB',
        key: 'avgHoldTime',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Thời gian trả lời TB',
        key: 'avgAcdTime',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Thời gian đàm thoại Max',
        key: 'longestAcdTime',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
    ];
    if (groups.includes(ReportGroupBy.Campaign)) {
      data = [
        {
          title: 'Chiến dịch',
          key: 'campaignId',
          display: true,
          allowSort: false,
          classes: '',
        },
        ...data,
      ];
    }
    if (groups.includes(ReportGroupBy.Queue)) {
      data = [
        {
          title: 'Hàng đợi',
          key: 'queueId',
          display: true,
          allowSort: false,
          classes: '',
        },
        ...data,
      ];
    }
    if (groups.includes(ReportGroupBy.Source)) {
      data = [
        {
          title: 'Nguồn',
          key: 'source',
          display: true,
          allowSort: false,
          classes: '',
        },
        ...data,
      ];
    }
    if (groups.includes(ReportGroupBy.Hour)) {
      data = [
        {
          title: 'Giờ',
          key: 'hr',
          display: true,
          allowSort: false,
          classes: '',
        },
        ...data,
      ];
    }
    if (groups.includes(ReportGroupBy.Day)) {
      data = [
        {
          title: 'Ngày',
          key: 'dt',
          display: true,
          allowSort: false,
          classes: '',
        },
        ...data,
      ];
    }
    if (groups.includes(ReportGroupBy.Group)) {
      data = [
        {
          title: 'Bộ phận',
          key: 'groupName',
          display: true,
          allowSort: false,
          classes: '',
        },
        ...data,
      ];
    }
    data = [
      {
        title: 'Chuyên viên',
        key: 'display_name',
        display: true,
        allowSort: false,
        classes: '',
      },
      ...data,
    ];
    return data;
  };
  static displayMissRatioColumn = ratio => {
    return ratio + '%';
  };
  static displayNameColumn = (item, agents) => {
    const a = agents.find(a => a.id == item.agentId || a.email == item.agentId || a.phone == item.agentId);
    return a ? a.text : 'Không xác định';
  };
  static displayGroup = (item, group) => {
    const a = group.find(a => a.id === item.groupId);
    return a ? a.text : 'Không xác định';
  };
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/reportv2/agentV1/agentV1.const.ts